'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserAvatar = function (_Component) {
  (0, _inherits3.default)(UserAvatar, _Component);

  function UserAvatar(props) {
    (0, _classCallCheck3.default)(this, UserAvatar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserAvatar.__proto__ || (0, _getPrototypeOf2.default)(UserAvatar)).call(this, props));

    _this.hideOverlayBound = _this.hideOverlay.bind(_this);
    _this.showOverlayBound = _this.showOverlay.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(UserAvatar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          borderRadius = _props.borderRadius,
          photoUrl = _props.photoUrl,
          isMentor = _props.isMentor,
          clickHandler = _props.clickHandler,
          _props$displayTooltip = _props.displayTooltip,
          displayTooltip = _props$displayTooltip === undefined ? true : _props$displayTooltip;


      var tooltipId = Math.floor(Math.random() * 1000000) + 1;
      var style = {
        width: (size || 0) + 'px',
        height: (size || 0) + 'px',
        borderRadius: (borderRadius || 0) + 'px'
      };

      return _react2.default.createElement(
        'div',
        { className: 'avatar' },
        _react2.default.createElement(
          'div',
          {
            className: 'user-photo-wrapper',
            style: style,
            onClick: clickHandler || undefined,
            onMouseOver: this.showOverlayBound,
            onMouseOut: this.hideOverlayBound,
            'data-tip': 'Mentor',
            'data-for': '' + tooltipId },
          _react2.default.createElement('img', { src: photoUrl, style: style }),
          _react2.default.createElement(
            'div',
            { className: 'overlay', style: style },
            '\xA0'
          ),
          isMentor && _react2.default.createElement('div', {
            className: 'mentor',
            style: { borderWidth: '0 0 ' + size / 3 + 'px ' + size / 3 + 'px' } })
        ),
        isMentor && displayTooltip && _react2.default.createElement(_reactTooltip2.default, { id: '' + tooltipId, effect: 'solid' })
      );
    }
  }, {
    key: 'showOverlay',
    value: function showOverlay(e) {
      e.currentTarget.classList.add('avatar-hovered');
    }
  }, {
    key: 'hideOverlay',
    value: function hideOverlay(e) {
      e.currentTarget.classList.remove('avatar-hovered');
    }
  }]);
  return UserAvatar;
}(_react.Component);

exports.default = UserAvatar;


UserAvatar.propTypes = {
  size: _propTypes2.default.number,
  borderRadius: _propTypes2.default.number,
  photoUrl: _propTypes2.default.string,
  clickHandler: _propTypes2.default.func,
  isMentor: _propTypes2.default.bool,
  displayTooltip: _propTypes2.default.bool
};